import React from "react";
import SEO from "src/components/General/SEO";
import { CategoryContent } from "src/models/CategoryContent";
import ScrollCards, { ScrollCardItem } from "src/components/ScrollCards/ScrollCards";
import { navigate } from "gatsby";
import { Container, Row, Col } from "reactstrap";
import { GatsbyImage } from "gatsby-plugin-image";
// tslint:disable:max-line-length
export interface CategoryComponentProps {
  pageContext: CatPageContext;
}
export interface CatPageContext {
  data: CategoryContent;
}

const CategoryComponent: React.FunctionComponent<CategoryComponentProps> = (props: CategoryComponentProps) => {
  const { data } = props.pageContext;
  const nav = () => {
    navigate(`${data.search.p}`);
  };
  let profiles: ScrollCardItem[] = [];
  if (data.profiles && data.profiles.length) {
    profiles = data.profiles.map((p) => {
      return {
        title: p.name,
        subtitle: p.profession,
        image: `https://${process.env.PSYSUP_SITE_DOMAIN}/${p.thumbs[0]}`,
        url: p.profileType === "community" ? `/community/${p.slug}/` : `/network/${p.slug}/`,
      } as ScrollCardItem;
    });
  }
  return (
    <Container className="category">
      <SEO title={data.seo.title} description={data.seo.desc} pathname={`/${data.path}/${data.slug}/`} />
      <Row>
        <Col>
          <GatsbyImage
            image={data.image.childImageSharp.featured}
            imgClassName="featured-img img-fluid"
            loading="lazy"
            alt={`Featured Image: ${data.title}`}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <h1>{data.title}</h1>
          {data.subtitle}
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          <h5>{data.content.title}</h5>
          <div dangerouslySetInnerHTML={{ __html: data.content.desc }} />
        </Col>
      </Row>
      <Row>
        <Col>
          <h5>{data.search.title}</h5>
          <div dangerouslySetInnerHTML={{ __html: data.search.desc }} />
          {profiles && profiles.length > 0 && <ScrollCards items={profiles} seeAllCb={nav} />}
        </Col>
      </Row>
    </Container>
  );
};

export default CategoryComponent;
